import React, { useState } from "react";
import {
  useTable,
  List,
  EditButton,
  ShowButton,
  DeleteButton,
  CreateButton,
} from "@refinedev/antd";
import { Table, Space, Input, Select } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { DELETE_DEFAULT_COMMITTEE_MUTATION, DEFAULT_COMMITTEE_LIST_QUERY } from "./queries";

interface IDefaultCommitteeRow {
  id: string;
  name: string;
  applicableMinuteTypes?: string[];
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export const DefaultCommitteeList: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [isActiveFilter, setIsActiveFilter] = useState<string>("");

  const { tableProps } = useTable<IDefaultCommitteeRow>({
    resource: "defaultCommittees",
    initialSorter: [{ field: "createdAt", order: "asc" }],
    initialPageSize: 10,
    meta: {
      gqlQuery: DEFAULT_COMMITTEE_LIST_QUERY,
    },
    filters: {
      permanent: [
        ...(isActiveFilter
          ? [{ field: "isActive", operator: "eq" as const, value: isActiveFilter === "true" }]
          : []),
      ],
    },
  });

  const dataSource: IDefaultCommitteeRow[] = (
    (tableProps as any)?.dataSource || []
  ).filter(
    (row: IDefaultCommitteeRow) =>
      !searchTerm ||
      row.name?.toLowerCase?.().includes(searchTerm.toLowerCase())
  );

  return (
    <List
      headerProps={{
        extra: (
          <Space>
            <Input
              placeholder="Search by name..."
              prefix={<SearchOutlined />}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onPressEnter={(e) => setSearchTerm(e.currentTarget.value)}
              style={{ width: 280 }}
            />
            <Select
              placeholder="Filter by Status"
              value={isActiveFilter}
              onChange={setIsActiveFilter}
              style={{ width: 140 }}
              allowClear
            >
              <Select.Option value="true">Active</Select.Option>
              <Select.Option value="false">Inactive</Select.Option>
            </Select>
            <CreateButton />
          </Space>
        ),
      }}
    >
      <Table {...tableProps} dataSource={dataSource as any} rowKey="id">
        <Table.Column dataIndex="name" title="Committee Name" sorter />
        <Table.Column
          dataIndex="applicableMinuteTypes"
          title="Applicable Minute Types"
          sorter
          render={(types?: string[]) =>
            types?.map((type) => type.toLowerCase().replace("_", " ")).join(", ")
          }
        />
        <Table.Column
          dataIndex="isActive"
          title="Status"
          sorter
          render={(isActive: boolean) => (
            <span style={{ color: isActive ? "#52c41a" : "#ff4d4f" }}>
              {isActive ? "Active" : "Inactive"}
            </span>
          )}
        />
        <Table.Column dataIndex="createdAt" title="Created Date" sorter />
        <Table.Column
          title="Actions"
          dataIndex="actions"
          render={(_text: string, record: IDefaultCommitteeRow) => (
            <Space>
              <EditButton
                size="small"
                recordItemId={record.id}
                resource="defaultCommittees"
              />
              <DeleteButton
                size="small"
                recordItemId={record.id}
                meta={{ gqlMutation: DELETE_DEFAULT_COMMITTEE_MUTATION }}
                resource="defaultCommittees"
              />
              <ShowButton
                size="small"
                recordItemId={record.id}
                resource="defaultCommittees"
              />
            </Space>
          )}
        />
      </Table>
    </List>
  );
};
